import { render, staticRenderFns } from "./OrderShipmentCreate.vue?vue&type=template&id=b29f0b62&"
import script from "./OrderShipmentCreate.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports